import React, { useState } from 'react';

const ApiKeyModal = ({ onConfirm, onCancel, initialKey }) => {
  const [key, setKey] = useState(initialKey || '');

  const handleSubmit = () => {
    if (key.trim()) {
      onConfirm(key.trim());
    }
  };

  return (
    <div className="creator-modal-overlay" onClick={onCancel}>
      <div className="creator-modal" onClick={(e) => e.stopPropagation()}>
        <h3>输入 API Key</h3>
        <input
          className="creator-modal-input"
          type="password"
          placeholder="sk-..."
          value={key}
          onChange={(e) => setKey(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleSubmit();
          }}
          autoFocus
        />
        <div className="creator-modal-hint">
          API Key 仅存储在浏览器本地，不会发送到服务器保存
        </div>
        <div className="creator-modal-actions">
          <button className="creator-modal-btn secondary" onClick={onCancel}>
            取消
          </button>
          <button
            className="creator-modal-btn primary"
            onClick={handleSubmit}
            disabled={!key.trim()}
          >
            确认
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApiKeyModal;
